import { React } from 'imports';
import DropPanel from '../DropPanel/DropPanel';
import TimeStamp from '../TimeStamp/TimeStamp';
import { resourcePropType } from 'typed/components/common/FormattedResource/FormattedResource';
import PeriodCalendar, { PeriodType, DateAlignment, periodTypePropType } from '../PeriodCalendar/PeriodCalendar';
import withDateLocaleUtils, { dateLocaleUtilsPropTypes } from '../withDateLocaleUtils/withDateLocaleUtils';
import DateRange from 'utils/DateRange';
import './PeriodSelect.less';

export { PeriodType, DateAlignment, periodTypePropType };

class PeriodSelect extends React.PureComponent {
    static get PeriodType() {
        return PeriodType;
    }

    static get DateAlignment() {
        return DateAlignment;
    }

    static get periodTypePropType() {
        return periodTypePropType;
    }

    static get propTypes() {
        return {
            ...dateLocaleUtilsPropTypes,
            ...PeriodCalendar.propTypes,
            placeholder: resourcePropType
        }
    }

    static get defaultProps() {
        return PeriodCalendar.defaultProps;
    }

    state = { opened: false }

    _onOpen = () => {
        this.setState({ opened: true });
    }

    _onChangeBy = (delta) => {
        this._onChange(this, new DateRange(this.props.value.periodType, this.props.value.last).move(delta));
    }

    _onChange = (sender, value) => {
        if (this.props.onChange) {
            this.props.onChange(this, value);
        }

        this._onClose();
    }

    _onClose = () => {
        this.setState({ opened: false });
    }

    render() {
        const { inline, value, minDate, maxDate, disabled, placeholder, className } = this.props;

        return (
            <div className={'period-select ' + (inline ? 'inline ' : '') + className}>
                {inline ? <button className="inline fa fa-chevron-left" disabled={!value || minDate && value.previous <= new DateRange(value.periodType, minDate).last} onClick={this._onChangeBy.bind(this, -1)} /> : null}
                <DropPanel
                    ref="drop-panel"
                    className="period-select-drop-panel"
                    title={
                        value ?
                            <TimeStamp detalizationPeriodType={value.periodType} exactDatePeriodType={null} value={value.last} /> :
                            <span className="placeholder">{placeholder !== undefined ? placeholder : this.props.getDateFormat()}</span>
                    }
                    icon={!inline ? 'calendar' : null}
                    disabled={disabled}
                    opened={!!this.state.opened}
                    onOpen={this._onOpen}
                    onClose={this._onClose}>
                    <PeriodCalendar {...this.props} onChange={this._onChange} />
                </DropPanel>
                {
                    inline ?
                        <button className="inline fa fa-chevron-right" disabled={!value || maxDate && value.next >= new DateRange(value.periodType, maxDate).next} onClick={this._onChangeBy.bind(this, 1)} /> :
                        null
                }
            </div>
        )
    }
}

export default withDateLocaleUtils(PeriodSelect);